<div class="card card--no-padding">
  <div class="access-points__wrapper">
    @if (!hasAccessPoints()) {
      <div class="access-points__empty">
        <div class="access-points__visual access-points__visual--empty">
          <img
            class="access-points__image access-points__image--empty"
            alt=""
            src="assets/images/aps/fallback-aruba.webp"
            loading="lazy"
          />
        </div>
        <p class="access-points__empty-text">{{ "Wireless.Ap.NoAccessPoints" | translate }}</p>
      </div>
    } @else {
      <div class="access-points" #scrollarea (scroll)="checkScroll()">
        @for (summary of accessPointSummaries(); track $index) {
          <div class="access-points__item">
            <div class="access-points__item-left">
              <div class="access-points__visual">
                <img
                  class="access-points__image"
                  [alt]="'Wireless.Ap.ImageAlt' | translate: { model: summary.model }"
                  [src]="getAccessPointImageUrl(summary.model)"
                  [attr.data-brand]="summary.brand"
                  (error)="onAccessPointImageError($event)"
                  loading="lazy"
                />
              </div>
            </div>
            <div class="access-points__item-right">
              <div class="access-points__model">{{ "Wireless.Ap.Model" | translate: { model: summary.model } }}</div>
              <div class="access-points__item-info">
                <span>{{ "Wireless.Ap.Active" | translate }}</span> {{ summary.active }}
              </div>
              <div class="access-points__item-info">
                <span>{{ "Wireless.Ap.Inactive" | translate }}</span> {{ summary.inactive }}
              </div>
              <div class="access-points__item-info">
                <span>{{ "Wireless.Ap.Total" | translate }}</span> {{ summary.total }}
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (leftEnabled()) {
      <button
        type="button"
        class="access-points__control access-points__control--prev"
        [attr.aria-label]="'Wireless.Ap.ScrollLeft' | translate"
        (click)="scrollLeft()"
      >
        <svg-icon class="access-points__control-icon" src="assets/images/icons/chevron-down.svg"> </svg-icon>
      </button>
    }
    @if (rightEnabled()) {
      <button
        type="button"
        class="access-points__control access-points__control--next"
        [attr.aria-label]="'Wireless.Ap.ScrollRight' | translate"
        (click)="scrollRight()"
      >
        <svg-icon class="access-points__control-icon" src="assets/images/icons/chevron-down.svg"> </svg-icon>
      </button>
    }
  </div>
</div>
